<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${serviceSlug}`), disabled: true },
        { title: $t('evocall.history.title'), disabled: true }
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="querySearch" />
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />
        <va-popover
          v-if="isSupervisor"
          class="ml-2"
          placement="left"
          :message="$t('statistics2.ops_stats.downloadExcel')">
          <span class="icon i-cloud-download" @click.prevent="downloadExcel"></span>
        </va-popover>
      </div>
    </Breadcrumbs>

    <TableView
      ref="tableView"
      :filters.sync="filters"
      :component="component"
      :service="component.service"
      :serviceSlug="serviceSlug"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      :customQueries="customQueries"
      @filters-updated="onFiltersUpdated"
    />

  </div>
</template>
<script>
import TableView from './TableView'
import Filters from '@/components/common/Filters'
import Searchable from '@/components/common/Searchable'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import { TABLE_VIRTUAL_WAITING_ROOM_HISTORY} from '@/local-storage/LocalStorageKeys'
import { RequestService } from '@/api/VirtualWaitingRoomService';
import { mapState } from 'vuex';


export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  mixins: [
    IndexTablesMixin
  ],
  components: {
    Filters,
    TableView,
    Searchable,
    Breadcrumbs
  },
  data () {
    return {
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_VIRTUAL_WAITING_ROOM_HISTORY,
      customQueries: null,
      filters: {
        appointmentTypes: [],
        creators: [],
        acceptees: [],
        consultationTypes: [],
        dateRange: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD')
        }
      },
    }
  },
  methods: {
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },

    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    downloadExcel() {
      let params = {}
      if(this.filters.creators.length > 0) {
        params.creators = this.filters.creators.map(creator => creator.id).join(",")
      }
      if(this.filters.acceptees.length > 0) {
        params.acceptees = this.filters.acceptees.map(acceptee => acceptee.id).join(",")
      }
      if(this.filters.appointmentTypes.length > 0) {
        params.appointmentTypes = this.filters.appointmentTypes.flatMap(type => type.bdIds).join(",")
      }

      params.start = this.filters.dateRange.start
      params.end = this.filters.dateRange.end

      this.isExportingExcelToast = this.showToast(this.$t('biosigns.accessCodes.exporting'), {
        ...this.$store.state.successToastOptions,
        icon: 'cloud-download',
        duration: null
      })

      RequestService.exportHistoryExcel(params).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'historico_sala_espera.xlsx')
        document.body.appendChild(link)
        link.click()
        this.isExportingExcelToast.goAway(100)
      }).catch(err => {
        console.log(err)
        this.isExportingExcelToast.goAway(100)
        setTimeout(() => {
          this.showToast(this.$t('statistics2.ops_stats.downloadExcelGenericFailure'), this.$store.state.errorToastOptions)
        }, 500)
      }).finally(() =>{
        this.isExportingExcelToast = null
      })
    }
  },
  computed: {
    ...mapState({
      infoTypes(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/infoTypes`]
      },
      accessTypes(state, getters) {
        return getters[`${this.waitingRoomModuleKey}/accessTypes`]
      }
    }),
    waitingRoomModuleKey: function () {
      return `virtualWaitingRoom`
    },
    virtualWaitingRoomService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.virtual_waiting_room_server) || null
    },
    isSupervisor: function() {
      return this.virtualWaitingRoomService.user_permissions.some(permission => permission.info_type === this.infoTypes.REQUESTS && permission.access_type >= this.accessTypes.ADMIN)
    }
  }
}
</script>


